import { inject, Injectable } from '@angular/core';
import { HttpCoreService } from '@dataclouder/ngx-core';
import { ILearningUserState } from '../models/knowledge.models';

const Endpoints = {
  GetKnowledgeUserStats: 'api/knowledge/user-stats',
  KnowledgeLearningExperience: 'api/knowledge/learning-experience',
};

@Injectable({
  providedIn: 'root',
})
export class KnowledgeLearningSystemService {
  // Services
  private httpCoreService = inject(HttpCoreService);

  async getUserStats(path: string) {
    // learningExperiences are saved in user_learning_experiences { experience: {}} every path is a level of knowledge, so 'en' are all activites relating to english
    const response = await this.httpCoreService.post(`${Endpoints.GetKnowledgeUserStats}`, { path });
    return response;
  }

  async saveProgress(progress: ILearningUserState) {
    const response = await this.httpCoreService.post(`${Endpoints.KnowledgeLearningExperience}`, progress);
    return response;
  }

  async getKnowledgeState(endPoint: string, path: string): Promise<Record<string, ILearningUserState>> {
    const response = await this.httpCoreService.get(`${endPoint}/${path}`);

    return response;
  }
}
